import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteFiltersService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }
  urlRoute = `${API_BASE_URL}/filters`;

  // getBOMDetails(itemId: number): Observable<{
  //   item: any;
  //   duplicate: boolean;
  //   bom: BillOfMaterials[];
  // }> {
  //   return this.http.get<{
  //     item: any;
  //     duplicate: boolean;
  //     bom: BillOfMaterials[];
  //   }>(`${this.urlRoute}/bom/${itemId}`);
  // }

  approveWorkOrder(data: {
    workOrderId: number;
    machineId: number;
    status: 'approved' | 'rejected';
  }): Observable<any> {
    return this.http.post<any>(`${this.urlRoute}/item-status`, {
      ...data,
    });
  }
}
